export default {
    list: {
        title: 'Activity',
        subtitle: 'Visualizza attività recente',
        loading: 'Caricamento attività...',
    },
    sender: {
        title: 'Activity',
        subtitle: 'Aggiornamenti e notifiche per il tuo account Sender',
    },
    shipper: {
        title: 'Activity',
        subtitle: 'Aggiornamenti e notifiche per il tuo account Shipper',
    },
    receiver: {
        title: 'Activity',
        subtitle: 'Aggiornamenti e notifiche per il tuo account Receiver',
    },
    freightForwarder: {
        title: 'Activity',
        subtitle: 'Aggiornamenti operativi per il tuo account Freight Forwarder',
    },
};
